import { useParams, useNavigate } from 'react-router-dom';
import { useGetTrackedUserDetailsByIdQuery } from '../../app/userApi/userApi';
import './TrackingUserDetails.css';
import { FaCheckCircle } from 'react-icons/fa';
import { MdPending } from 'react-icons/md';
import { IoArrowBack } from 'react-icons/io5';

const TrackingUserDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data, isLoading } = useGetTrackedUserDetailsByIdQuery({ id });

  const userDetails = data?.data;

  const steps = [
    { key: 'stepLocationSelection', label: 'Location Selection' },
    { key: 'stepEnergyUsage', label: 'Energy Usage' },
    { key: 'stepQuestionnaire', label: 'Questionnaire' },
    { key: 'stepInstallationAreaSelection', label: 'Installation Area Selection' },
    { key: 'stepRoofSelection', label: 'Roof Selection' },
    { key: 'stepPanelSelection', label: 'Panel Selection', showRoofDecision: true },
    { key: 'stepFormSubmission', label: 'Form Submission' },
  ];

  if (isLoading) {
    return <div className="loading-container">Loading...</div>;
  }

  if (!userDetails) {
    return <div className="no-data-container">No data found</div>;
  }

  return (
    <div className="tracking-details-container p-3">
      <div className="details-card">
        <div className="details-header">
          <button 
            className="back-btn" 
            onClick={() => navigate('/user-tracking', { state: { activeTab: 'odoUsers' } })}
          >
            <IoArrowBack size={20} />
            <span>Back</span>
          </button>
          <h2 className="details-title">User Tracking Details</h2>
        </div>

        <div className="info-grid">
          <div className="info-box">
            <span className="info-label">IP Address</span>
            <span className="info-value">{userDetails.host_ip || '-'}</span>
          </div>
          <div className="info-box">
            <span className="info-label">Country</span>
            <span className="info-value">{userDetails.host_country || '-'}</span>
          </div>
          <div className="info-box">
            <span className="info-label">Browser</span>
            <span className="info-value">{userDetails.host_browser || 'Unknown'}</span>
          </div>
          <div className="info-box">
            <span className="info-label">Device</span>
            <span className="info-value" style={{ textTransform: 'capitalize' }}>
              {userDetails.host_device || '-'}
            </span>
          </div>
          <div className="info-box">
            <span className="info-label">Address</span>
            <span className="info-value" style={{ textTransform: 'capitalize' }}>
              {userDetails.address || '-'}
            </span>
          </div>
          <div className="info-box">
            <span className="info-label">Postcode</span>
            <span className="info-value" style={{ textTransform: 'capitalize' }}>
              {userDetails.post_code || '-'}
            </span>
          </div>
        </div>

        <div className="steps-timeline">
          {steps.map((step, index) => {
            const isCompleted = userDetails[step.key] === true;
            return (
              <div key={step.key} className="step-item">
                <div className={`step-icon ${isCompleted ? 'completed' : 'pending'}`}>
                  {isCompleted ? (
                    <FaCheckCircle size={24} />
                  ) : (
                    <MdPending size={24} />
                  )}
                </div>
                <div className="step-content">
                  <h4 className="step-label">{step.label}</h4>
                  <span className={`step-status ${isCompleted ? 'completed' : 'pending'}`}>
                    {isCompleted ? 'Completed' : 'Pending'}
                  </span>
                  {step.showRoofDecision && userDetails.stepRoofDrawDecision && (
                    <span className="roof-decision">
                      Roof Draw Decision: {userDetails.stepRoofDrawDecision}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TrackingUserDetails;
